import React, { useState, useEffect } from "react";
import TextArea from "antd/es/input/TextArea";
import { useParams } from "react-router-dom";
import SisLoader from "../../../../widgets/loader";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { lightGreen } from "@mui/material/colors";

const newObject = {
  title: [
    "Basic Engine",
    "Main Engine",
    "Auxiliary Engine",
    "Auxiliary Machinery",
    "Cargo Machinery",
  ],
};

const AuxilaryRemarksLog = () => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const COMMENT_LIST_API = async (staff_dashboard) => {
    set_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
    FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
    try {
      post(ApiURL.view_eng_comment_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newArray = res?.comments.map((items, index) => {
            const title = newObject.title[index % newObject.title.length];
            return {
              ...items,
              title: title,
            };
          });

          setFilteredData(newArray);
        }
        set_loader(false);
      });
    } catch (error) {
      set_loader(false);
      console.error("Error fetching comments list:", error);
    } finally {
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    if (parsedData) {
      COMMENT_LIST_API(parsedData);
    }
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {filteredData?.length > 0 ? (
              <>
                {filteredData?.map((item) => {
                  return (
                    <>
                      <div className="row" style={{ marginBottom: "1%" }}>
                        <div className="col-12">
                          <h3
                            style={{
                              color: "#161515",
                            }}
                          >
                            {item?.title} :-
                          </h3>
                          <div className="input-box">
                            <label>{item?.name}</label>
                            <TextArea
                              disabled
                              rows={5}
                              placeholder="Comments ...."
                              value={item?.comments}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AuxilaryRemarksLog;
